module.exports = __webpack_public_path__ + "img/DCIImg09.e382f387.png";